<div class="card genreCard" style="width: 18rem;">
    <img class="card-img-top" [src]="genre.photoURL" alt="Card image cap">
    <div class="card-body">
      <h5 class="card-title generName">{{genre.name}}</h5>
    </div>
  </div>